import { render } from "./Sounds.vue?vue&type=template&id=5c2a516c&scoped=true"
import script from "./Sounds.vue?vue&type=script&lang=js"
export * from "./Sounds.vue?vue&type=script&lang=js"

import "./Sounds.vue?vue&type=style&index=0&id=5c2a516c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2a516c"]])

export default __exports__